import NodeDatabaseProperty from "../components/molecules/node-database-property";
export const dbType = "Database";
export const mrTypes = [
  {
    type: dbType,
    propertyComponent: NodeDatabaseProperty,
    properties: {
      style: {
        backgroundColor: "#ffffff",
        borderRadius: "15px",
        border: "4px solid #003E60",
        height: 140,
        width: 150,
        icon: {
          node: "none",
          bar: "dbModel",
        },
        textStyle: {
          borderBottom: "4px solid #003E60",
          fontSize: "13px",
          fontWeight: 600,
          width: "150px",
          height: "45px",
          marginInnerTextTop: "4px", //propiedad custom para centrar verticalmente el texto de los nodos
        },
      },
      source: [],
      attributes: [],
    },
    ports: {
      port1: {
        id: "port1",
        type: "input",
        height: "25px",
        width: "25px",
        viewBox: "0 0 25 25",
        properties: {
          mode: "input",
          design: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z",
        },
      },
      port2: {
        id: "port2",
        type: "output",
        height: "25px",
        width: "25px",
        viewBox: "0 0 25 25",
        properties: {
          mode: "output",
          design: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z",
        },
      },
    },
  },
];
